import {
  Identifiable,
  project,
  Project,
  resource,
  Resource,
  ResourceTypes,
} from "@planzone/dto";

type SpentTime = {
  date: string;
  time: number;
  isAvailable: boolean;
};

type ProjectTimeSheet = {
  project: Identifiable<Project>;
  timesheetDeadline: string;
  spentTimes: SpentTime[];
  integratedAt: string;
  totalSpentHours: number;
  totalAllocatedHours: number;
  totalAllocationsCount: number;
  resources: (Identifiable<Resource> & {
    totalOfAllocatedHours: number;
    totalOfSpentTime: number;
    totalOfSpentTimeInWeek: number;
    totalOfSpentTimeUntilEndDate: number;
    totalOfRemainingTime: number;
    percentCompletion: number;
    spentTimes: SpentTime[];
    resourceRemoved?: boolean;
  })[];
};

const projectTimeSheet: ProjectTimeSheet = {
  spentTimes: [],
  timesheetDeadline: "",
  project: {
    ...project,
    uuid: "",
  },
  resources: [],
  integratedAt: "",
  totalSpentHours: 0,
  totalAllocatedHours: 0,
  totalAllocationsCount: 0,
};

export type { ProjectTimeSheet };

export { projectTimeSheet };
